import React, { Component } from "react";
import { MDBDataTable } from "mdbreact";
import {
  Card,
  CardBody,
  Col,
  Row,
  FormGroup,
  Label,
  Button,
  Modal,
  Container,
  ModalHeader,
  ModalBody,
  Badge,
  Input,
  CustomInput,
} from "reactstrap";
import {
  getTeamMembers,
  getAvailableModules,
  createTeamMember,
  updateTeamMember,
  updateTeamPermissions,
  deleteTeamMember,
  resetTeamMemberPassword,
} from "../../Endpoint/Admin/index";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { ToastContainer, toast } from "react-toastify";
import { AvForm, AvField } from "availity-reactstrap-validation";
import ConfirmModal from "../../components/Common/ConfirmModal";

// Module Categories Configuration
const MODULE_CATEGORIES = {
  dashboard: {
    name: "Dashboard & Analytics",
    icon: "ri-dashboard-line",
    color: "#5664d2",
    modules: ["DASHBOARD", "ANALYTICS"]
  },
  kitchen: {
    name: "Kitchen & Food",
    icon: "ri-restaurant-line",
    color: "#f1b44c",
    modules: ["FOOD"]
  },
  tableBooking: {
    name: "Table Booking",
    icon: "ri-calendar-check-line",
    color: "#ff6b6b",
    modules: ["TABLE"]
  },
  rooms: {
    name: "Room Management",
    icon: "ri-hotel-bed-line",
    color: "#50a5f1",
    modules: ["ROOM"]
  },
  facilities: {
    name: "Facilities & Services",
    icon: "ri-service-line",
    color: "#f46a6a",
    modules: ["ATTRACTION", "TAXI"]
  },
  transport: {
    name: "Transportation",
    icon: "ri-car-line",
    color: "#17a2b8",
    modules: ["TRANSPORTATION", "DRIVERS"]
  },
  users: {
    name: "User Management",
    icon: "ri-user-line",
    color: "#343a40",
    modules: ["USERS"]
  },
  communication: {
    name: "Communication",
    icon: "ri-message-2-line",
    color: "#6c757d",
    modules: ["CHAT", "NOTIFICATION"]
  },
  marketing: {
    name: "Marketing & Promotions",
    icon: "ri-gift-line",
    color: "#e83e8c",
    modules: ["COUPON", "BANNER"]
  },
  system: {
    name: "System",
    icon: "ri-settings-3-line",
    color: "#6f42c1",
    modules: ["SETTINGS"]
  },
};

class TeamList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      modules: [],
      isLoaded: false,
      modal: false,
      permissionModal: false,
      passwordModal: false,

      // Form fields
      memberId: "",
      firstName: "",
      lastName: "",
      email: "",
      mobile: "",
      password: "",
      selectedModules: [],
      newPassword: "",
      confirmPassword: "",
      showNewPassword: false,
      showConfirmPassword: false,
      passwordResetSuccess: false,
      resetMemberName: "",

      // Delete modal states
      showDeleteModal: false,
      selectedMemberId: null,
      deleteLoading: false,

      breadcrumbItems: [
        { title: "Dashboard", link: "/dashboard" },
        { title: "Team Management", link: "#" },
      ],
      tableData: {
        columns: [
          { label: "Name", field: "name", sort: "asc", width: 150 },
          { label: "Email", field: "email", sort: "asc", width: 150 },
          { label: "Mobile", field: "mobile", sort: "asc", width: 100 },
          { label: "Status", field: "status", sort: "asc", width: 80 },
          { label: "Modules", field: "modules", sort: "asc", width: 200 },
          { label: "Actions", field: "actions", sort: "asc", width: 200 },
        ],
        rows: [],
      },
    };

    this.toggle = this.toggle.bind(this);
    this.togglePermission = this.togglePermission.bind(this);
    this.togglePassword = this.togglePassword.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleModuleChange = this.handleModuleChange.bind(this);
  }

  toggle(resetFields = true) {
    if (resetFields) {
      this.setState({
        modal: !this.state.modal,
        memberId: "",
        firstName: "",
        lastName: "",
        email: "",
        mobile: "",
        password: "",
        selectedModules: [],
      });
    } else {
      this.setState({ modal: !this.state.modal });
    }
  }

  togglePermission() {
    this.setState({ permissionModal: !this.state.permissionModal });
  }

  togglePassword() {
    this.setState({
      passwordModal: !this.state.passwordModal,
      newPassword: "",
      confirmPassword: "",
      showNewPassword: false,
      showConfirmPassword: false,
      passwordResetSuccess: false,
    });
  }

  // Delete modal toggle
  toggleDeleteModal = () => this.setState({ showDeleteModal: !this.state.showDeleteModal });

  handleChange = (e) => {
    this.setState({ [e.target.id]: e.target.value });
  };

  handleModuleChange = (moduleId) => {
    const { selectedModules } = this.state;
    if (selectedModules.includes(moduleId)) {
      this.setState({
        selectedModules: selectedModules.filter((id) => id !== moduleId),
      });
    } else {
      this.setState({
        selectedModules: [...selectedModules, moduleId],
      });
    }
  };

  // Handle category select all
  handleCategorySelectAll = (categoryKey) => {
    const { selectedModules, modules } = this.state;
    const category = MODULE_CATEGORIES[categoryKey];
    const categoryModuleIds = category.modules.filter(modId =>
      modules.some(m => m.moduleId === modId)
    );

    const allSelected = categoryModuleIds.every(modId => selectedModules.includes(modId));

    if (allSelected) {
      // Deselect all in category
      this.setState({
        selectedModules: selectedModules.filter(id => !categoryModuleIds.includes(id))
      });
    } else {
      // Select all in category
      const newSelected = [...new Set([...selectedModules, ...categoryModuleIds])];
      this.setState({ selectedModules: newSelected });
    }
  };

  // Handle master select all
  handleSelectAll = () => {
    const { selectedModules, modules } = this.state;
    const allModuleIds = modules.map(m => m.moduleId);

    if (selectedModules.length === allModuleIds.length) {
      this.setState({ selectedModules: [] });
    } else {
      this.setState({ selectedModules: allModuleIds });
    }
  };

  // Check if category is fully selected
  isCategoryFullySelected = (categoryKey) => {
    const { selectedModules, modules } = this.state;
    const category = MODULE_CATEGORIES[categoryKey];
    const categoryModuleIds = category.modules.filter(modId =>
      modules.some(m => m.moduleId === modId)
    );
    return categoryModuleIds.length > 0 && categoryModuleIds.every(modId => selectedModules.includes(modId));
  };

  // Check if category is partially selected
  isCategoryPartiallySelected = (categoryKey) => {
    const { selectedModules, modules } = this.state;
    const category = MODULE_CATEGORIES[categoryKey];
    const categoryModuleIds = category.modules.filter(modId =>
      modules.some(m => m.moduleId === modId)
    );
    const selectedCount = categoryModuleIds.filter(modId => selectedModules.includes(modId)).length;
    return selectedCount > 0 && selectedCount < categoryModuleIds.length;
  };

  // Get modules for a category
  getCategoryModules = (categoryKey) => {
    const { modules } = this.state;
    const category = MODULE_CATEGORIES[categoryKey];
    return modules.filter(m => category.modules.includes(m.moduleId));
  };

  handleSubmit(e) {
    e.preventDefault();
    const { memberId, firstName, lastName, email, mobile, password, selectedModules } = this.state;

    if (memberId) {
      // Update existing member
      updateTeamMember(memberId, { firstName, lastName, email, mobile })
        .then((response) => {
          if (response.status === 200) {
            toast.success("Team member updated successfully");
            this.getAllTeamMembers();
            this.toggle();
          } else {
            toast.error(response.message || "Failed to update team member");
          }
        })
        .catch(() => toast.error("Error updating team member"));
    } else {
      // Create new member
      createTeamMember({ firstName, lastName, email, mobile, password, modulePermissions: selectedModules })
        .then((response) => {
          if (response.status === 200) {
            toast.success("Team member created successfully");
            this.getAllTeamMembers();
            this.toggle();
          } else {
            toast.error(response.message || "Failed to create team member");
          }
        })
        .catch(() => toast.error("Error creating team member"));
    }
  }

  handlePermissionSubmit = () => {
    const { memberId, selectedModules } = this.state;
    updateTeamPermissions(memberId, selectedModules)
      .then((response) => {
        if (response.status === 200) {
          toast.success("Permissions updated successfully");
          this.getAllTeamMembers();
          this.togglePermission();
        } else {
          toast.error(response.message || "Failed to update permissions");
        }
      })
      .catch(() => toast.error("Error updating permissions"));
  };

  handlePasswordSubmit = () => {
    const { memberId, newPassword, confirmPassword } = this.state;

    // Validation
    if (!newPassword.trim()) {
      toast.error("Please enter a new password");
      return;
    }
    if (newPassword.length < 6) {
      toast.error("Password must be at least 6 characters");
      return;
    }
    if (!confirmPassword.trim()) {
      toast.error("Please confirm the password");
      return;
    }
    if (newPassword !== confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }

    resetTeamMemberPassword(memberId, newPassword)
      .then((response) => {
        if (response.status === 200) {
          toast.success("Password reset successfully");
          this.setState({ passwordResetSuccess: true });
        } else {
          toast.error(response.message || "Failed to reset password");
        }
      })
      .catch(() => toast.error("Error resetting password"));
  };

  copyPasswordToClipboard = () => {
    const { newPassword } = this.state;
    navigator.clipboard.writeText(newPassword).then(() => {
      toast.success("Password copied to clipboard");
    }).catch(() => {
      toast.error("Failed to copy password");
    });
  };

  getAllTeamMembers() {
    getTeamMembers()
      .then((result) => {
        if (result.status === 200) {
          const rows = result.data.map((member) => ({
            name: `${member.firstName} ${member.lastName}`,
            email: member.email,
            mobile: member.mobile,
            status: member.isActive ? (
              <Badge color="success">Active</Badge>
            ) : (
              <Badge color="danger">Inactive</Badge>
            ),
            modules: (
              <div>
                {(member.modulePermissions || []).slice(0, 3).map((mod) => (
                  <Badge key={mod} color="info" className="mr-1 mb-1" style={{ fontSize: '10px' }}>
                    {mod.replace(/_/g, ' ')}
                  </Badge>
                ))}
                {(member.modulePermissions || []).length > 3 && (
                  <Badge color="secondary" style={{ fontSize: '10px' }}>+{member.modulePermissions.length - 3}</Badge>
                )}
              </div>
            ),
            actions: (
              <div className="d-flex gap-1">
                <Button
                  color="primary"
                  size="sm"
                  className="mr-1 btn-icon"
                  onClick={() => this.editMember(member)}
                  title="Edit Member"
                  style={{ minWidth: '32px', padding: '4px 8px' }}
                >
                  <i className="ri-edit-line" style={{ fontSize: '14px' }}></i>
                </Button>
                <Button
                  color="info"
                  size="sm"
                  className="mr-1 btn-icon"
                  onClick={() => this.openPermissions(member)}
                  title="Manage Permissions"
                  style={{ minWidth: '32px', padding: '4px 8px' }}
                >
                  <i className="ri-shield-user-line" style={{ fontSize: '14px' }}></i>
                </Button>
                <Button
                  color="warning"
                  size="sm"
                  className="mr-1 btn-icon"
                  onClick={() => this.openPasswordReset(member)}
                  title="Reset Password"
                  style={{ minWidth: '32px', padding: '4px 8px' }}
                >
                  <i className="ri-lock-password-line" style={{ fontSize: '14px' }}></i>
                </Button>
                <Button
                  color="danger"
                  size="sm"
                  className="btn-icon"
                  onClick={() => this.deleteMember(member._id)}
                  title="Delete Member"
                  style={{ minWidth: '32px', padding: '4px 8px' }}
                >
                  <i className="ri-delete-bin-line" style={{ fontSize: '14px' }}></i>
                </Button>
              </div>
            ),
          }));

          this.setState({
            isLoaded: true,
            items: result.data,
            tableData: { ...this.state.tableData, rows },
          });
        }
      })
      .catch(() => toast.error("Error fetching team members"));
  }

  getAllModules() {
    getAvailableModules()
      .then((result) => {
        if (result.status === 200) {
          // Filter out TEAM module (only super admin manages team)
          const modules = result.data.filter((m) => m.moduleId !== "TEAM");
          this.setState({ modules });
        }
      })
      .catch(() => toast.error("Error fetching modules"));
  }

  editMember(member) {
    this.setState({
      memberId: member._id,
      firstName: member.firstName,
      lastName: member.lastName,
      email: member.email,
      mobile: member.mobile,
      selectedModules: member.modulePermissions || [],
    }, () => {
      this.toggle(false); // Don't reset fields when editing
    });
  }

  openPermissions(member) {
    this.setState({
      memberId: member._id,
      selectedModules: member.modulePermissions || [],
    });
    this.togglePermission();
  }

  openPasswordReset(member) {
    this.setState({
      memberId: member._id,
      resetMemberName: `${member.firstName} ${member.lastName}`,
      passwordModal: true,
      newPassword: "",
      confirmPassword: "",
      showNewPassword: false,
      showConfirmPassword: false,
      passwordResetSuccess: false,
    });
  }

  deleteMember(id) {
    this.setState({ selectedMemberId: id, showDeleteModal: true });
  }

  confirmDelete = () => {
    const { selectedMemberId } = this.state;
    this.setState({ deleteLoading: true });
    deleteTeamMember(selectedMemberId)
      .then((response) => {
        if (response.status === 200) {
          toast.success("Team member deleted successfully");
          this.getAllTeamMembers();
        } else {
          toast.error(response.message || "Failed to delete team member");
        }
      })
      .catch(() => toast.error("Error deleting team member"))
      .finally(() => {
        this.setState({ deleteLoading: false, showDeleteModal: false, selectedMemberId: null });
      });
  }

  componentDidMount() {
    this.getAllTeamMembers();
    this.getAllModules();
  }

  // Render categorized permissions
  renderPermissionCategories() {
    const { selectedModules, modules } = this.state;
    const allModuleIds = modules.map(m => m.moduleId);
    const isAllSelected = allModuleIds.length > 0 && selectedModules.length === allModuleIds.length;

    return (
      <div className="permission-categories">
        {/* Select All Header */}
        <div
          className="select-all-header mb-4 p-3 rounded"
          style={{
            background: 'var(--brand-primary)',
            color: 'var(--text-inverse)'
          }}
        >
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <h5 className="mb-1 text-white">
                <i className="ri-shield-user-line mr-2"></i>
                Module Permissions
              </h5>
              <small className="text-white-50">
                {selectedModules.length} of {allModuleIds.length} modules selected
              </small>
            </div>
            <div className="custom-control custom-switch">
              <input
                type="checkbox"
                className="custom-control-input"
                id="selectAllModules"
                checked={isAllSelected}
                onChange={this.handleSelectAll}
              />
              <label className="custom-control-label text-white" htmlFor="selectAllModules">
                Select All
              </label>
            </div>
          </div>
        </div>

        {/* Category Grid */}
        <Row>
          {Object.entries(MODULE_CATEGORIES).map(([key, category]) => {
            const categoryModules = this.getCategoryModules(key);
            if (categoryModules.length === 0) return null;

            const isFullySelected = this.isCategoryFullySelected(key);
            const isPartiallySelected = this.isCategoryPartiallySelected(key);

            return (
              <Col md={6} lg={4} key={key} className="mb-4">
                <Card className="h-100 shadow-sm border-0">
                  <CardBody className="p-0">
                    {/* Category Header */}
                    <div
                      className="category-header p-3 d-flex justify-content-between align-items-center"
                      style={{
                        background: category.color,
                        borderRadius: '4px 4px 0 0'
                      }}
                    >
                      <div className="d-flex align-items-center">
                        <i className={`${category.icon} mr-2`} style={{ fontSize: '20px', color: 'var(--text-inverse)' }}></i>
                        <span className="font-weight-bold text-white">{category.name}</span>
                      </div>
                      <div className="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          id={`category-${key}`}
                          checked={isFullySelected}
                          ref={(input) => {
                            if (input) input.indeterminate = isPartiallySelected;
                          }}
                          onChange={() => this.handleCategorySelectAll(key)}
                        />
                        <label
                          className="custom-control-label"
                          htmlFor={`category-${key}`}
                          style={{ color: 'var(--text-inverse)' }}
                        >
                          All
                        </label>
                      </div>
                    </div>

                    {/* Module List */}
                    <div className="module-list p-3">
                      {categoryModules.map((module) => (
                        <div
                          key={module.moduleId}
                          className="module-item d-flex align-items-start mb-2 p-2 rounded"
                          style={{
                            background: selectedModules.includes(module.moduleId)
                              ? `${category.color}15`
                              : 'var(--table-stripe-bg)',
                            border: selectedModules.includes(module.moduleId)
                              ? `1px solid ${category.color}40`
                              : '1px solid transparent',
                            transition: 'all 0.2s ease'
                          }}
                        >
                          <div className="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              id={`module-${module.moduleId}`}
                              checked={selectedModules.includes(module.moduleId)}
                              onChange={() => this.handleModuleChange(module.moduleId)}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor={`module-${module.moduleId}`}
                            >
                              <span className="font-weight-medium">{module.moduleName}</span>
                              {module.description && (
                                <small className="d-block text-muted" style={{ fontSize: '11px' }}>
                                  {module.description}
                                </small>
                              )}
                            </label>
                          </div>
                        </div>
                      ))}
                    </div>
                  </CardBody>
                </Card>
              </Col>
            );
          })}
        </Row>
      </div>
    );
  }

  render() {
    const { modules, selectedModules, memberId } = this.state;

    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <Breadcrumbs title="Team Management" breadcrumbItems={this.state.breadcrumbItems} />

            <Row>
              <Col xs={12}>
                <Card>
                  <CardBody>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <h4 className="card-title mb-0">Team Members</h4>
                      <Button color="primary" onClick={this.toggle}>
                        <i className="ri-user-add-line mr-1"></i> Add Team Member
                      </Button>
                    </div>

                    {/* Add/Edit Modal */}
                    <Modal isOpen={this.state.modal} toggle={this.toggle} size="xl">
                      <ModalHeader toggle={this.toggle} className="bg-light">
                        <i className={`${memberId ? 'ri-edit-line' : 'ri-user-add-line'} mr-2`}></i>
                        {memberId ? "Edit Team Member" : "Add Team Member"}
                      </ModalHeader>
                      <ModalBody>
                        <AvForm onValidSubmit={this.handleSubmit}>
                          <Card className="bg-light mb-4">
                            <CardBody>
                              <h5 className="mb-3">
                                <i className="ri-user-line mr-2"></i>
                                Personal Information
                              </h5>
                              <Row>
                                <Col md={6}>
                                  <FormGroup>
                                    <Label>First Name</Label>
                                    <AvField
                                      type="text"
                                      id="firstName"
                                      name="firstName"
                                      value={this.state.firstName}
                                      onChange={this.handleChange}
                                      required
                                      placeholder="Enter first name"
                                    />
                                  </FormGroup>
                                </Col>
                                <Col md={6}>
                                  <FormGroup>
                                    <Label>Last Name</Label>
                                    <AvField
                                      type="text"
                                      id="lastName"
                                      name="lastName"
                                      value={this.state.lastName}
                                      onChange={this.handleChange}
                                      required
                                      placeholder="Enter last name"
                                    />
                                  </FormGroup>
                                </Col>
                              </Row>
                              <Row>
                                <Col md={6}>
                                  <FormGroup>
                                    <Label>Email</Label>
                                    <AvField
                                      type="email"
                                      id="email"
                                      name="email"
                                      value={this.state.email}
                                      onChange={this.handleChange}
                                      required
                                      placeholder="Enter email address"
                                    />
                                  </FormGroup>
                                </Col>
                                <Col md={6}>
                                  <FormGroup>
                                    <Label>Mobile</Label>
                                    <AvField
                                      type="number"
                                      id="mobile"
                                      name="mobile"
                                      value={this.state.mobile}
                                      onChange={this.handleChange}
                                      required
                                      placeholder="Enter mobile number"
                                    />
                                  </FormGroup>
                                </Col>
                              </Row>
                              {!memberId && (
                                <Row>
                                  <Col md={6}>
                                    <FormGroup>
                                      <Label>Password</Label>
                                      <AvField
                                        type="password"
                                        id="password"
                                        name="password"
                                        value={this.state.password}
                                        onChange={this.handleChange}
                                        required
                                        minLength={6}
                                        placeholder="Minimum 6 characters"
                                      />
                                    </FormGroup>
                                  </Col>
                                </Row>
                              )}
                            </CardBody>
                          </Card>

                          {!memberId && (
                            <>
                              {this.renderPermissionCategories()}
                            </>
                          )}

                          <div className="text-center mt-4">
                            <Button color="secondary" className="mr-2" onClick={this.toggle}>
                              Cancel
                            </Button>
                            <Button color="primary" type="submit">
                              <i className={`${memberId ? 'ri-save-line' : 'ri-add-line'} mr-1`}></i>
                              {memberId ? "Update Member" : "Create Member"}
                            </Button>
                          </div>
                        </AvForm>
                      </ModalBody>
                    </Modal>

                    {/* Permission Modal */}
                    <Modal isOpen={this.state.permissionModal} toggle={this.togglePermission} size="xl">
                      <ModalHeader toggle={this.togglePermission} className="bg-light">
                        <i className="ri-shield-user-line mr-2"></i>
                        Manage Module Permissions
                      </ModalHeader>
                      <ModalBody>
                        {this.renderPermissionCategories()}
                        <div className="text-center mt-4">
                          <Button color="secondary" className="mr-2" onClick={this.togglePermission}>
                            Cancel
                          </Button>
                          <Button color="primary" onClick={this.handlePermissionSubmit}>
                            <i className="ri-save-line mr-1"></i>
                            Save Permissions
                          </Button>
                        </div>
                      </ModalBody>
                    </Modal>

                    {/* Password Reset Modal */}
                    <Modal isOpen={this.state.passwordModal} toggle={this.togglePassword}>
                      <ModalHeader toggle={this.togglePassword} className="bg-warning text-white">
                        <i className="ri-lock-password-line mr-2"></i>
                        Reset Password
                      </ModalHeader>
                      <ModalBody>
                        {this.state.resetMemberName && (
                          <div className="alert alert-light border mb-3">
                            <i className="ri-user-line mr-2"></i>
                            Resetting password for: <strong>{this.state.resetMemberName}</strong>
                          </div>
                        )}

                        {!this.state.passwordResetSuccess ? (
                          <>
                            {/* New Password Field */}
                            <FormGroup>
                              <Label>New Password <span className="text-danger">*</span></Label>
                              <div style={{ position: "relative" }}>
                                <input
                                  type={this.state.showNewPassword ? "text" : "password"}
                                  className={`form-control ${this.state.newPassword && this.state.newPassword.length < 6 ? "border-danger" : ""}`}
                                  id="newPassword"
                                  value={this.state.newPassword}
                                  onChange={this.handleChange}
                                  placeholder="Minimum 6 characters"
                                  style={{ paddingRight: "45px" }}
                                />
                                <button
                                  type="button"
                                  onClick={() => this.setState({ showNewPassword: !this.state.showNewPassword })}
                                  style={{
                                    position: "absolute",
                                    right: "10px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    background: "none",
                                    border: "none",
                                    cursor: "pointer",
                                    padding: "5px",
                                    color: "#505d69",
                                  }}
                                >
                                  <i className={this.state.showNewPassword ? "ri-eye-off-line" : "ri-eye-line"} style={{ fontSize: "18px" }}></i>
                                </button>
                              </div>
                              {this.state.newPassword && this.state.newPassword.length < 6 && (
                                <small className="text-danger">Password must be at least 6 characters</small>
                              )}
                            </FormGroup>

                            {/* Confirm Password Field */}
                            <FormGroup>
                              <Label>Confirm Password <span className="text-danger">*</span></Label>
                              <div style={{ position: "relative" }}>
                                <input
                                  type={this.state.showConfirmPassword ? "text" : "password"}
                                  className={`form-control ${this.state.confirmPassword && this.state.newPassword !== this.state.confirmPassword ? "border-danger" : ""}`}
                                  id="confirmPassword"
                                  value={this.state.confirmPassword}
                                  onChange={this.handleChange}
                                  placeholder="Re-enter password"
                                  style={{ paddingRight: "45px" }}
                                />
                                <button
                                  type="button"
                                  onClick={() => this.setState({ showConfirmPassword: !this.state.showConfirmPassword })}
                                  style={{
                                    position: "absolute",
                                    right: "10px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    background: "none",
                                    border: "none",
                                    cursor: "pointer",
                                    padding: "5px",
                                    color: "#505d69",
                                  }}
                                >
                                  <i className={this.state.showConfirmPassword ? "ri-eye-off-line" : "ri-eye-line"} style={{ fontSize: "18px" }}></i>
                                </button>
                              </div>
                              {this.state.confirmPassword && this.state.newPassword !== this.state.confirmPassword && (
                                <small className="text-danger">Passwords do not match</small>
                              )}
                              {this.state.confirmPassword && this.state.newPassword === this.state.confirmPassword && this.state.newPassword.length >= 6 && (
                                <small className="text-success"><i className="ri-check-line mr-1"></i>Passwords match</small>
                              )}
                            </FormGroup>

                            <div className="text-center mt-4">
                              <Button color="secondary" className="mr-2" onClick={this.togglePassword}>
                                Cancel
                              </Button>
                              <Button
                                color="warning"
                                onClick={this.handlePasswordSubmit}
                                disabled={!this.state.newPassword || this.state.newPassword.length < 6 || this.state.newPassword !== this.state.confirmPassword}
                              >
                                <i className="ri-lock-password-line mr-1"></i>
                                Reset Password
                              </Button>
                            </div>
                          </>
                        ) : (
                          <>
                            {/* Success State with Copy Option */}
                            <div className="text-center mb-4">
                              <i className="ri-checkbox-circle-line text-success" style={{ fontSize: "60px" }}></i>
                              <h5 className="mt-3 text-success">Password Reset Successfully!</h5>
                            </div>

                            <div className="alert alert-success">
                              <div className="d-flex justify-content-between align-items-center">
                                <div>
                                  <small className="text-muted d-block">New Password:</small>
                                  <strong style={{ fontFamily: "monospace", fontSize: "16px" }}>
                                    {this.state.showNewPassword ? this.state.newPassword : "••••••••"}
                                  </strong>
                                </div>
                                <div>
                                  <Button
                                    color="light"
                                    size="sm"
                                    className="mr-2"
                                    onClick={() => this.setState({ showNewPassword: !this.state.showNewPassword })}
                                    title={this.state.showNewPassword ? "Hide password" : "Show password"}
                                  >
                                    <i className={this.state.showNewPassword ? "ri-eye-off-line" : "ri-eye-line"}></i>
                                  </Button>
                                  <Button
                                    color="primary"
                                    size="sm"
                                    onClick={this.copyPasswordToClipboard}
                                    title="Copy password"
                                  >
                                    <i className="ri-file-copy-line mr-1"></i>
                                    Copy
                                  </Button>
                                </div>
                              </div>
                            </div>

                            <div className="alert alert-warning mt-3">
                              <i className="ri-information-line mr-2"></i>
                              <small>Please share this password securely with the user. They should change it after first login.</small>
                            </div>

                            <div className="text-center mt-4">
                              <Button color="success" onClick={this.togglePassword}>
                                <i className="ri-check-line mr-1"></i>
                                Done
                              </Button>
                            </div>
                          </>
                        )}
                      </ModalBody>
                    </Modal>

                    <MDBDataTable
                      responsive
                      bordered
                      striped
                      hover
                      noBottomColumns
                      data={this.state.tableData}
                      entriesOptions={[5, 10, 25, 50]}
                      entries={10}
                      pagesAmount={4}
                      className="mt-3"
                    />
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>

        {/* Delete Confirmation Modal */}
        <ConfirmModal
          isOpen={this.state.showDeleteModal}
          toggle={this.toggleDeleteModal}
          onConfirm={this.confirmDelete}
          title="Delete Team Member"
          message="Are you sure you want to delete this team member? This action cannot be undone."
          confirmText="Delete"
          confirmColor="danger"
          icon="ri-delete-bin-line"
          loading={this.state.deleteLoading}
        />

        <ToastContainer />
      </React.Fragment>
    );
  }
}

export default TeamList;
